import React from 'react'
import ReactDOM from 'react-dom/client'
import { Route, BrowserRouter, Routes } from 'react-router'
import { queryClient } from './queryClient'

import AuthWrapper from './components/AuthWrapper';

import LoginPage from './login/page';
import LoginTokenPage from './login/token/page';
import LogoutPage from './logout/page';
import OnboardPage from './onboard/page';
import UsuariosPage from './usuario/page';
import PerfilPage from './perfil/page';
import RelatoriosPage from './pages/relatorios/page';
import AccessReportsPage from './pages/relatorios/acessos/page';
import { Navigate } from 'react-router-dom';

import { QueryClientProvider } from 'react-query';
import { ApplianceProvider } from './lib/ApplianceContext';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import LegacyDomainBanner from './components/LegacyDomainBanner';

import './theme-default.css'
import './index.css';
import AppliancesPage from './pages/appliances/page'
import AgentesPage from './pages/agentes/page'
import FirewallPage from './pages/firewall/page'
import RoutingRedirectPage from './pages/appliances/RoutingRedirectPage'
import NatPage from './pages/nat/page'
import VPNPage from './pages/vpn/page'
import DispositivosPage from './pages/dispositivos/page'
import HotspotPage from './pages/hotspot/page'
import RedesPage from './pages/appliances/RedesPage'
import SquidPage from './pages/appliances/SquidPage'
import DnsCachePage from './pages/appliances/DnsCachePage'
import QosPage from './pages/appliances/QosPage'
import ConexoesPage from './pages/conexoes/ConexoesPage'
import TrafegoLinksPage from './pages/conexoes/TrafegoLinksPage'
import RadiusPage from './pages/radius/page'
import PortalPage from './portal/page'
import NotFoundPage from './pages/notfound/page'
import AuditoriaPage from './pages/auditoria/page'
import McpPage from './pages/mcp/page'
import AlertasPage from './pages/alertas/page'
import ConfiguracoesPage from './pages/configuracoes/page'
import { getRouterBasename } from './lib/tenant'
import { setupAxiosTenantHeader } from './lib/axiosTenant'
import { ThemeProvider } from './lib/ThemeContext'

setupAxiosTenantHeader();

const basename = getRouterBasename();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={basename}>
        <Routes>
          {/* Rota pública — fora do ApplianceProvider para não disparar GET /api/appliance,
              e fora do ThemeProvider: o portal cativo usa as cores do hotspot, e o provider
              carimbaria data-theme/color-scheme no <html> conforme o tema do celular do
              cliente, escurecendo body, checkboxes, dropdowns e a barra de rolagem. */}
          <Route path="/portal/:publicUid" element={<PortalPage />} />
          <Route path="/portal/:tenantKey/:publicUid" element={<PortalPage />} />

          {/* Todas as rotas autenticadas dentro do ThemeProvider + ApplianceProvider */}
          <Route path="/*" element={
            <ThemeProvider>
              <ApplianceProvider>
              <Routes>
                <Route path="/" element={<AuthWrapper><Navigate to="/appliances" replace /></AuthWrapper>} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/login/token" element={<LoginTokenPage />} />
                <Route path="/logout" element={<AuthWrapper><LogoutPage /></AuthWrapper>} />
                <Route path="/onboard" element={<OnboardPage />} />
                <Route path="/usuario" element={<AuthWrapper><UsuariosPage /></AuthWrapper>} />
                <Route path="/appliances" element={<AuthWrapper><AppliancesPage /></AuthWrapper>} />
                <Route path="/agentes" element={<AuthWrapper><AgentesPage /></AuthWrapper>} />
                <Route path="/appliances/:id/redirects" element={<AuthWrapper><RoutingRedirectPage /></AuthWrapper>} />
                <Route path="/firewall" element={<AuthWrapper><FirewallPage /></AuthWrapper>} />
                <Route path="/nat" element={<AuthWrapper><NatPage /></AuthWrapper>} />
                <Route path="/vpn" element={<AuthWrapper><VPNPage /></AuthWrapper>} />
                <Route path="/dispositivos" element={<AuthWrapper><DispositivosPage /></AuthWrapper>} />
                <Route path="/hotspot" element={<AuthWrapper><HotspotPage /></AuthWrapper>} />
                <Route path="/redes" element={<AuthWrapper><RedesPage /></AuthWrapper>} />
                <Route path="/redirects" element={<AuthWrapper><RoutingRedirectPage /></AuthWrapper>} />
                <Route path="/squid" element={<AuthWrapper><SquidPage /></AuthWrapper>} />
                <Route path="/dns-cache" element={<AuthWrapper><DnsCachePage /></AuthWrapper>} />
                <Route path="/controle-banda" element={<AuthWrapper><QosPage /></AuthWrapper>} />
                <Route path="/conexoes" element={<AuthWrapper><ConexoesPage /></AuthWrapper>} />
                <Route path="/trafego-links" element={<AuthWrapper><TrafegoLinksPage /></AuthWrapper>} />
                <Route path="/radius" element={<AuthWrapper><RadiusPage /></AuthWrapper>} />
                <Route path="/perfil" element={<AuthWrapper><PerfilPage /></AuthWrapper>} />
                <Route path="/auditoria" element={<AuthWrapper><AuditoriaPage /></AuthWrapper>} />
                <Route path="/mcp" element={<AuthWrapper><McpPage /></AuthWrapper>} />
                <Route path="/alertas" element={<AuthWrapper><AlertasPage /></AuthWrapper>} />
                <Route path="/configuracoes" element={<AuthWrapper><ConfiguracoesPage /></AuthWrapper>} />
                <Route path="/relatorios/acessos" element={<AuthWrapper><AccessReportsPage /></AuthWrapper>} />
                <Route path="/relatorios/:id" element={<AuthWrapper><RelatoriosPage /></AuthWrapper>} />
                <Route path="/relatorios" element={<AuthWrapper><RelatoriosPage /></AuthWrapper>} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
              </ApplianceProvider>
            </ThemeProvider>
          } />
        </Routes>
      </BrowserRouter>
      <LegacyDomainBanner />
      <ToastContainer />
    </QueryClientProvider>
  </React.StrictMode>,
)
